import { Product } from '../../models/product'
import { Variant } from '../../models/variant'
import { productState } from './index'

export const getProduct = (): Product => {
  return {
    ...productState.product
  }
}

export const getVariants = (): Variant[] => {
  const product = getProduct()
  return product.variants.slice(0)
}

export const getCurrentVariant = (): Variant => {
  return {
    ...productState.currentVariant
  }
}

export const getDefaultVariant = (): Variant => {
  const variants = getVariants()
  return variants[0]
}

export const getProductPrice = (): number => {
  return productState.product.price
}

export const getVariant = (variantId: number): Variant | undefined => {
  const variant = getProduct().variants.find(v => v.id === variantId)
  return {
    ...variant
  }
}
